import React from "react";
import { NavLink, useParams } from "react-router-dom";
import { CustomSubHeader } from "../../../components/subheader";

export default function AccountDetailsSubheader({ active, children }) {
  const params = useParams();
  const links = [
    { name: "Campaigns", to: `/accounts/${params.accountId}/campaigns`, type: "text" },
    { name: "Campaign Pricing", to: `/accounts/${params.accountId}/campaign-pricing`, type: "text" },
    { name: "Team Members", to: `/accounts/${params.accountId}/team-members`, type: "text" },
    { name: "Wallet", to: `/accounts/${params.accountId}/wallet`, type: "text" },
    { name: "Sessions", to: `/accounts/${params.accountId}/sessions`, type: "text" },
    { name: "Settings", to: `/accounts/${params.accountId}/settings`, type: "text" },
    { name: "RCS Bot", to: `/accounts/${params.accountId}/rcs-bot-config`, type: "text" },
    { name: "Summary", to: `/accounts/${params.accountId}/summary`, type: "text" },
    // { name: "Vendor Accounts", to: "/#", type: "text" },
  ];
  return (
    <CustomSubHeader>
      <div className="d-flex flex-stack w-100">
        <div className="menu menu-xs-rounded menu-xs-row menu-state-bg menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch">
          {links.map((link, index) => (
            <div key={index} className="menu-item me-lg-1">
              <NavLink className={`menu-link py-3 ${active === link.name ? "active" : ""}`} to={link.to}>
                <span className="menu-title">{link.name}</span>
              </NavLink>
            </div>
          ))}
        </div>
        <div>{children}</div>
      </div>
    </CustomSubHeader>
  );
}
